import { useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const LoginMicrosoft = () => {
  const [searchParams] = useSearchParams();

  const handleMicrosoftLogin = () => {
    // Get the redirect path from query params
    const redirectPath = searchParams.get("redirect") || "/";

    // Build the callback URL - Strapi will redirect back here after OAuth
    const callbackUrl = `${window.location.origin}/login/microsoft/callback?redirect=${encodeURIComponent(redirectPath)}`;

    // Redirect to Strapi's Microsoft OAuth endpoint
    const apiUrl = import.meta.env.VITE_API_URL;
    const microsoftOAuthUrl = `${apiUrl}/api/connect/microsoft?redirect=${encodeURIComponent(callbackUrl)}`;

    window.location.href = microsoftOAuthUrl;
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-gray-800 border-gray-700">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <img
              src="/images/autoclipper-logo-full.png"
              alt="Autoclipper Logo"
              className="h-12 w-auto"
            />
          </div>
          <CardTitle className="text-2xl font-bold text-white">Entrar com Microsoft</CardTitle>
          <CardDescription className="text-gray-400">
            Clique no botão abaixo para fazer login com sua conta Microsoft
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            onClick={handleMicrosoftLogin}
            className="w-full bg-gradient-to-r from-lime-400 to-cyan-400 hover:from-lime-500 hover:to-cyan-500 text-black font-semibold rounded-full shadow-lg flex items-center justify-center gap-2"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="0" y="0" width="10" height="10" fill="#F25022" />
              <rect x="13" y="0" width="10" height="10" fill="#7FBA00" />
              <rect x="0" y="13" width="10" height="10" fill="#00A4EF" />
              <rect x="13" y="13" width="10" height="10" fill="#FFB900" />
            </svg>
            Entrar com Microsoft
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginMicrosoft;

